// Shared module-level navigation state used by the react-router-dom mock.
// Exported so consumers can call isPopNavigation() without needing
// non-standard properties on the history object.

export const _navActionRef = { current: 'PUSH' };
export const _wasPopNavigation = { current: false };

export const isPopNavigation = () => _wasPopNavigation.current;
